import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import * as appUtilityFunction from '../../../../infrastructure/apputilityfunctions'
export default function Cards({ dashboardId }) {

    const dashboardData = useSelector(state => state.dashboardReducer.userDashboard.userdashboardData);
    if (dashboardData === null) {
        return <div />;
    }
    let datas = dashboardData[dashboardId];
    let dataRows = datas.dataRows;
    if (dataRows.length === 0) {
        return <div></div>;
    }
    const chartLabels = dataRows.map(row => {
        const chartLabel = row.fields.find(field => field.fieldName === 'CHARTLABEL');
        return chartLabel ? chartLabel.fieldValue : null;
    }).filter(label => label !== null);
    //get all chart value
    /*const chartValues = dataRows.map(row => {
        const chartValue = row.fields.find(field => field.fieldName === 'CHARTVALUE');
        return chartValue ? chartValue.fieldValue : null;
    }).filter(value => value !== null);   */
    const chartValues = dataRows.map(row => {
        const chartValueField = row.fields.find(field => field.fieldName === 'CHARTVALUE');
        const fieldValue = chartValueField ? JSON.stringify(chartValueField.fieldValue) : null;
        const chartValue = fieldValue !== '{}' ? fieldValue : null;
        return chartValue !== null && chartValue !== '0' ? chartValue : null;
    }).filter(value => value !== null);
    
    
    return (
        <div class="col-xl-3">
            <div class="card">
                <div class="card-body">

                    <div class="d-flex">
                        <div class="flex-shrink-0">
                            <div class="avatar-sm rounded">
                                <span class="avatar-title bg-primary-lighten h3 my-0 text-primary rounded">
                                    <i class="mdi mdi-chart-areaspline"></i>
                                </span>
                            </div>
                        </div>
                        <div class="flex-grow-1 ms-3">
                            <h4 class="mt-0 mb-1 font-20">{chartLabels}</h4>
                            {chartValues < 0  ?
                            <h3>{chartValues.length >0 && <text style={{ color: '#C35959' } }> {appUtilityFunction.addCommasToValue(chartValues)}</text> } </h3>
                            :
                            <h3>{chartValues.length >0 && appUtilityFunction.addCommasToValue(chartValues)} </h3>
                             }
                            {/* <p class="mb-0 text-muted"><i class="mdi mdi-arrow-up-bold text-success"></i> {chartLabels}</p> */}
                        </div>
                    </div>

                    {/* <div class="row align-items-end justify-content-between mt-3">
                        
                        <div class="col-sm-5">
                            <div class="text-end">
                                <div id="currency-btc-chart" data-colors="#536de6"></div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>

        /*  <div class="col-md-3">
              <div class="card border-primary border">
                  <div class="card-body" >
                      <i class="mdi mdi-chart-bell-curve-cumulative " style={{ 'font-size': '24px', }}></i>
                      <h5 class="card-title text-primary text-center">{chartLabels}</h5>
                      <p class="card-text text-center">
                          <h2> {chartValues} </h2>
                      </p>
                  </div>
              </div>
          </div>
      */


    )
}
